module.exports = __webpack_public_path__ + "img/horizontal_4_5_pp3_5010.d4f99691.png";